import React from 'react'
import { Field } from 'redux-form/immutable'

import Input from 'app/components/Input'
// @ts-ignore
import TextArea from 'app/components/TextArea'
import { trimmed } from 'helpers/reviews'

import { IReviewsSurveyAccessibleReviewerTypeSectionProps } from './interface'

import './styles.scss'
const bc = 'reviews-survey-accessible-reviewer-type'

const normalized = (value: string) => {
  const parsed = parseInt(value)
  if (parsed < 0 || isNaN(parsed)) {
    return '0'
  }
  return value
}

const ReviewsSurveyAccessibleReviewerTypeSection: React.FC<IReviewsSurveyAccessibleReviewerTypeSectionProps> = ({
  typeOfReviewer,
  validateTextArea,
  validateReviewerMin,
  validateReviewerMax,
  isPublished,
  t,
}) => {
  return (
    <div className={`${bc}__wrapper`}>
      <h3 className={`${bc}__title`}>{t('(X) Enable request for reviews', { typeOfReviewer })}</h3>
      <Field
        name={`${typeOfReviewer}Min`}
        component={Input}
        type="number"
        isRow
        label={t('Enter Minimum number of', { typeOfReviewer })}
        labelClass={`${bc}__label`}
        inputClass={`${bc}__input`}
        normalize={normalized}
        validate={[validateReviewerMin]}
        disabled={isPublished}
        title={isPublished ? t('Disabled because survey already is published') : undefined}
      />
      <Field
        name={`${typeOfReviewer}Max`}
        component={Input}
        type="number"
        isRow
        label={t('Enter Maximum number of', { typeOfReviewer })}
        labelClass={`${bc}__label`}
        inputClass={`${bc}__input`}
        normalize={normalized}
        validate={[validateReviewerMax]}
      />
      <Field
        name={`${typeOfReviewer}Instructions`}
        component={TextArea}
        label={`${t('Enter Instructions for requesting', { typeOfReviewer })}:`}
        maxCharacters={400}
        validate={validateTextArea}
        normalize={trimmed}
      />
    </div>
  )
}

export default ReviewsSurveyAccessibleReviewerTypeSection
